exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".option[data-v-015aac16]{display:inline-block}.option[data-v-015aac16]:not(:first-child){padding-left:10px}\n", ""]);

